import script from "./StoriesList.vue?vue&type=script&setup=true&lang=js"
export * from "./StoriesList.vue?vue&type=script&setup=true&lang=js"

import "./StoriesList.vue?vue&type=style&index=0&id=ba247afe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba247afe"]])

export default __exports__